import { useNavigate } from "react-router-dom";
import { Search, Bell, Command as CmdIcon, Menu, Activity } from "lucide-react";
import { useFilters } from "../../context/FiltersContext";
import { PERIODOS } from "../../lib/constants";

export default function Header({ onOpenCommand, onOpenMenu }) {
  const { filters, setFilters } = useFilters();
  const navigate = useNavigate();

  const selectCls =
    "h-9 rounded-xl bg-white/15 border border-white/25 text-white text-xs px-3 pr-8 focus:ring-2 focus:ring-white/40 outline-none appearance-none cursor-pointer hover:bg-white/20 transition";

  return (
    <header
      data-testid="app-header"
      className="h-14 md:h-16 sticky top-0 z-30 px-3 md:px-6 flex items-center justify-between text-white shadow-lg"
      style={{ background: "linear-gradient(135deg,#4c1d95 0%,#6d28d9 33%,#7c3aed 66%,#3b82f6 100%)" }}
    >
      <div className="flex items-center gap-2 md:gap-3">
        {/* Mobile menu button */}
        <button
          onClick={onOpenMenu}
          className="md:hidden h-9 w-9 rounded-xl bg-white/10 hover:bg-white/20 flex items-center justify-center border border-white/20 transition"
          aria-label="Abrir menú"
        >
          <Menu className="w-5 h-5" />
        </button>

        {/* Mobile logo */}
        <div className="md:hidden flex items-center gap-2">
          <div className="h-7 w-7 rounded-lg bg-white/20 flex items-center justify-center">
            <Activity className="w-4 h-4" />
          </div>
          <span className="text-xs font-bold">Viaje del Paciente</span>
        </div>

        {/* Desktop search */}
        <button
          data-testid="open-command-palette"
          onClick={onOpenCommand}
          className="hidden md:flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 rounded-xl px-3 h-9 text-xs text-white/90 transition"
        >
          <Search className="w-3.5 h-3.5" />
          <span>Buscar páginas, pacientes...</span>
          <kbd className="ml-6 flex items-center gap-1 bg-white/20 rounded px-1.5 py-0.5 text-[10px] font-mono">
            <CmdIcon className="w-3 h-3" /> K
          </kbd>
        </button>
      </div>

      <div className="flex items-center gap-1.5 md:gap-2">
        <select
          data-testid="filter-periodo"
          value={filters.periodo}
          onChange={(e) => setFilters({ ...filters, periodo: e.target.value })}
          className={`${selectCls} text-[10px] md:text-xs max-w-[120px] md:max-w-none`}
        >
          {PERIODOS.map((p) => <option key={p} value={p} className="text-slate-900">{p}</option>)}
        </select>

        <span
          data-testid="badge-datos-simulados"
          className="hidden sm:inline-flex items-center gap-1.5 px-2.5 h-7 rounded-full bg-amber-400/20 border border-amber-400/30 text-amber-100 text-[10px] font-semibold"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse" />
          Datos simulados
        </span>

        <button
          data-testid="notifications-btn"
          onClick={() => navigate("/alertas")}
          className="relative h-8 w-8 md:h-9 md:w-9 rounded-xl bg-white/10 hover:bg-white/20 flex items-center justify-center border border-white/20 transition"
          aria-label="Notificaciones"
        >
          <Bell className="w-4 h-4" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-rose-400 animate-pulse" />
        </button>

        <button
          data-testid="user-avatar"
          onClick={() => navigate("/usuarios")}
          className="h-8 w-8 md:h-9 md:w-9 rounded-xl overflow-hidden border-2 border-white/30 shadow-md bg-gradient-to-br from-violet-400 to-blue-400 flex items-center justify-center text-white text-[10px] md:text-xs font-bold cursor-pointer hover:opacity-90 transition"
        >
          UC
        </button>
      </div>
    </header>
  );
}
